import React from 'react';

const LegalsManagerConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_LEGAL', 'ROLE_LEGAL_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      exact: true,
      path: '/legals/participate',
      component: React.lazy(() =>
        import('./legal_participate/LegalsParticipate')
      )
    }
  ]
};

const LegalsListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_LEGAL', 'ROLE_LEGAL_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      exact: true,
      path: '/legals',
      component: React.lazy(() => import('./legals_list/Legals'))
    }
  ]
};

const LegalsEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_LEGAL', 'ROLE_LEGAL_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      exact: true,
      path: '/legals/:id',
      component: React.lazy(() => import('./legals_edit/LegalsEdit'))
    }
  ]
};

const LegalsAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_LEGAL', 'ROLE_LEGAL_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      exact: true,
      path: '/legals/new',
      component: React.lazy(() => import('./legals_add/LegalsAdd'))
    }
  ]
};

export {
  LegalsListConfig,
  LegalsAddConfig,
  LegalsEditConfig,
  LegalsManagerConfig
};
